import { ref } from 'vue';
import { defineStore } from 'pinia';
import { applyPatch } from 'fast-json-patch';

export const useAdminItemBiddingStore = defineStore('adminItemBiddingStore', () => {
    const items = ref({});

    function addItemBidding(itemBiddingModel) {
        items.value[itemBiddingModel.id] = itemBiddingModel;
    }

    function updateItemBidding(id, itemBiddingModel) {
        items.value[id] = itemBiddingModel;
    }

    function removeItemBidding(id) {
        delete items.value[id];
    }

    function applyJsonPatch(id, jsonPatch) {
        applyPatch(items.value[id], jsonPatch, false, true);
    }

    return {
        items,
        addItemBidding,
        updateItemBidding,
        removeItemBidding,
        applyJsonPatch
    }
})